import React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import styles from "./LoadingSpinner.module.scss";

export interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
    size?: "xs" | "sm" | "md" | "lg";
    className?: string;
}

const DefaultLoadingSpinner = ({ size = "md", className, ...props }: LoadingSpinnerProps) => {
    return (
        <div
            className={clsx(styles.spinner, className)}
            data-deci-loading-spinner="true"
            data-size={size}
            {...props}
        />
    );
};

const LoadingSpinner = createPluggable<LoadingSpinnerProps>("deci.loadingSpinner", DefaultLoadingSpinner);

export default LoadingSpinner;

